import {PolyDictionary} from '../../../../../../../@polygonjs/polygonjs/src/types/GlobalTypes';
import {Ref} from 'vue';
import {BaseCodeDisplayer} from './_Base';
import type {BuilderCopNode} from '../../../../../../../@polygonjs/polygonjs/src/engine/nodes/cop/Builder';
import type {BuilderPostNode} from '../../../../../../../@polygonjs/polygonjs/src/engine/nodes/post/Builder';

export class FragmentOnlyCodeDisplayer {
	static async update(
		node: BuilderCopNode | BuilderPostNode,
		shadersByName: Ref<PolyDictionary<string | null>>,
		shaderNames: Ref<string[]>
	) {
		await node.compute();
		BaseCodeDisplayer.clear(shadersByName, shaderNames);
		const fragment = node.shaders_by_name().fragment;
		shadersByName.value['fragment'] = fragment || null;
		shaderNames.value.push('fragment');
	}
}
